module.exports = __webpack_public_path__ + "img/visa-mastercard.8ff970e3.svg";